import { render, staticRenderFns } from "./RuleNumberOfCopies.vue?vue&type=template&id=6a899cd2"
import script from "./RuleNumberOfCopies.vue?vue&type=script&lang=js"
export * from "./RuleNumberOfCopies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports